import React, { useContext, useEffect, useState } from "react";
import "./Deposit_Not_Received.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Filter_Drop from "../Common/Common_Component/Filter_Drop/Filter_Drop";
import No_data from "../Common/No_data/No_data";
import { Context } from "../../utils/context";
import CustomPagination from "../Common/Common_Component/CustomPagination/CustomPagination";
import Deposit_Not_Received_Card from "./Deposit_Not_Received_Card/Deposit_Not_Received_Card";
import { useDispatch, useSelector } from "react-redux";
import { GetAllDepositHistory } from "../../features/wallet/slice";

function Deposit_Not_Received() {
  const [key, setKey] = useState("all");
  const [showDate, setShowDate] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedApp, setSelectedApp] = useState("All");
  const { signin } = useContext(Context);


  const options = [
    { label: "All", id: null },
    { label: "Pending", id: 1 }, // Processing
    { label: "Completed", id: 2 }, // Accepted
    { label: "Rejected", id: 3 },
  ];

  const dispatch = useDispatch();

  const depositeHistory = useSelector((state) => state.wallet);


  const fetch = async (page) => {
    await dispatch(GetAllDepositHistory({
      startDate: selectedDate,
      page,
      status: selectedApp?.id
    }))
  };

  useEffect(() => {
    if (signin)
      fetch(1);
  }, [dispatch, signin, selectedDate, selectedApp]);

  const handlePageChange = async (page) => {
    fetch(page)
  };

  return (
    <>
      <section className="Withdrawal_History_List">
        <Common_white_header headingText={"Recharge History"} />

        <div className="container">

          {depositeHistory?.data?.length > 0 ? (
            <Deposit_Not_Received_Card diposit_history={depositeHistory} />
          ) : (
            <No_data />
          )}
        </div>

        {depositeHistory?.total_pages > 1 && (
          <CustomPagination
            currentPage={depositeHistory?.current_page}
            totalPages={depositeHistory?.total_pages}
            handlePageChange={handlePageChange}
          />
        )}
      </section>
    </>
  );
}

export default Deposit_Not_Received;
